module.exports = __webpack_public_path__ + "img/ar-combine.ebae9aa9.png";